import { Slider } from '@vindr/ui';
import { Button, ConfigProvider, theme } from 'antd';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const SliceSelection = ({ onClose, onSuccess, maxSize = 60, message }) => {
  const [value, setValue] = useState([0, maxSize]);
  const { t } = useTranslation('ViewerTool');

  return (
    <ConfigProvider
      theme={{
        algorithm: theme.darkAlgorithm,
        token: {
          fontSize: 12,
          borderRadiusSM: 2,
          borderRadiusLG: 2,
          borderRadius: 2,
          colorPrimary: '#39C2D7',
          colorPrimaryHover: '#2799b0',
          colorText: '#fff',
          colorBgBase: '#172126',
          colorBgContainer: 'transparent',
          colorBorder: '#647a87',
          controlItemBgActiveDisabled: '#2C4654',
          controlItemBgActive: '#2C4654',
          controlOutlineWidth: 0,
          colorBgElevated: '#1F313B',
        },
        components: {
          Menu: {
            colorItemBg: 'transparent',
            colorItemBgSelected: '#2c5166',
          },
        },
      }}
    >
      <div className="warning">
        {t(message || 'VR might not work properly on low end device')}
      </div>
      <div className="warning">{t('Select slice to reconstruct')}:</div>
      <Slider
        range
        value={value}
        onChange={(val) => {
          setValue(val);
        }}
        marks={{ 0: '1', [maxSize - 1]: maxSize }}
        min={0}
        max={maxSize - 1}
        step={1}
        tooltip={{ formatter: (val: any) => val + 1 }}
      />
      {value[1] - value[0] < 3 && (
        <div className="text-[#DC4446]">
          {t('Number of slices does not reach minimum requirement')}
        </div>
      )}
      <div className="mt-4 flex justify-end">
        <Button className="mr-2" onClick={onClose}>
          {t('Cancel')}
        </Button>
        <Button
          type="primary"
          onClick={() => onSuccess(value)}
          disabled={value[1] - value[0] < 3}
        >
          {t('OK')}
        </Button>
      </div>
    </ConfigProvider>
  );
};

export default SliceSelection;
